<!-- confirm follow dialog -->
<p-dialog
  [modal]="true"
  [closable]="!loginUser || loginUser.class_id != 1 || loginUser.class_id != 2"
  [draggable]="false"
  [(visible)]="confirmFollowDialogFlag"
  styleClass="follow-dialog"
>
  <div class="header">
    課題フォロー
  </div>
  <div class="body">
    <div class="p-col-12 text-group p-d-flex p-ai-center p-jc-center">
      <!-- ui for user 1 2 -->
      <div class="p-col-11 text-large" *ngIf="loginUser && (loginUser.class_id == 1|| loginUser.class_id == 2) ">
        <h4 class="p-m-0">「{{agendaTitle}}」</h4>
        <h4 class="p-m-0" *ngIf="loginUser && (loginUser.member_id != member_id)">を課題フォローしますか？</h4>
      </div>
      <!-- ui for user 3 4 -->
      <div class="p-col-11 text-large" *ngIf="loginUser && (loginUser.class_id == 3|| loginUser.class_id == 9) ">
        <h4 class="p-m-0">
          課題フォロー機能は都道府県・市区町村（1号会員）及び府庁省（2号会員）向けの機能です。民間団体等（3号会員）には対応しておりません。
        </h4>
      </div>
      <!-- ui for not loged in -->
      <div class="p-col-11 text-large" *ngIf="!loginUser">
        <h4 class="p-m-0">「{{agendaTitle}}」</h4>
        <h4 class="p-m-0">を課題フォローするにはログイン/会員登録が必要です。</h4>
      </div>
      <div class="button-group p-d-flex p-jc-center">
        <button
          pButton
          type="button"
          label="OK"
          class="button-accept mr-4"
          (click)="confirmFollow()"
          *ngIf="loginUser && ((loginUser.class_id ==1 || loginUser.class_id ==2 ) && loginUser.member_id != member_id)"
          [disabled]="member_id == this.loginUser?.member_id"
          ></button>
        <button
          pButton
          type="button"
          label="ログイン"
          class="button-accept"
          (click)="loginToC104()"
          *ngIf="!loginUser"
        ></button>
        <button
          pButton
          type="button"
          label="キャンセル"
          class="button-cancel"
          *ngIf="loginUser && ((loginUser.class_id == 1 || loginUser.class_id == 2) && loginUser.member_id != member_id)"
          (click)="closeDialog()"
        ></button>
        <button
        pButton
        type="button"
        label="閉じる"
        class="button-accept"
        *ngIf="loginUser && (loginUser.class_id == 3 || loginUser.class_id == 9 || loginUser.member_id == member_id)"
        (click)="closeDialog()"
      ></button>
      </div>
      <!-- ui for not loged in -->
      <div class="button-group p-d-flex p-jc-center" *ngIf="!loginUser">
        <span (click)="moveA201()" class="link-text link-blue pointer">
          会員登録はこちら
        </span>
      </div>
      <div class="grey-zone p-mt-3 p-px-3 pb-2" *ngIf="!loginUser">
        <div class="p-d-flex p-ai-center p-jc-center">
          <div>
            <h4 class="p-my-2 tex-med">
              この課題に興味がある、または類似課題を持つ団体は<br>
              ぜひ課題をフォローしてください。
            </h4>
          </div>
        </div>
        ・課題をフォローをすると、貴団体もこの課題に対する提案を受けられます。<br>
        ・フォローした課題はマイページの「課題・ソリューション登録・管理」から確認できます。<br>
        ・課題フォローは後で取消しできます。<br>
        ・課題フォローするには事前にログイン/会員登録が必要です。<br>
        ・課題フォロー機能は都道府県・市区町村（1号会員）及び府庁省（2号会員）が利用可能です。<br>　民間団体等（３号会員）には対応しておりません。
      </div>
      <!-- ui for user 3 4 -->
      <div class="grey-zone p-mt-3 p-px-3 pb-2"
      *ngIf="loginUser && (loginUser.class_id == 3 || loginUser.class_id == 9)">
        <div class="p-d-flex p-ai-center p-jc-center">
          <div class=" p-text-center">
            <h4 class="p-my-2 tex-med">＊課題フォロー機能について</h4>
          </div>
        </div>
        ・課題をフォローしている団体がいる場合、<span class="p-text-bold">提案団体は、課題登録団体及びフォロー団体を</span><br/>
        <span class="p-text-bold">任意に選択して、提案を行うことが可能</span>です。<br/>
      </div>
      <!-- ui for user 1 2 -->
      <div class="grey-zone p-mt-3 p-px-3 pb-2"
      *ngIf="loginUser && ((loginUser.class_id == 1 || loginUser.class_id == 2) && loginUser.member_id != member_id)">
        <div class="p-d-flex p-ai-center p-jc-center">
          <div>
            <h4 class="p-my-2 tex-med">
              この課題に興味がある、または類似課題を持つ団体は<br>
              ぜひ課題をフォローしてください。
            </h4>
          </div>
        </div>
        ・課題をフォローをすると、貴団体もこの課題に対する提案を受けられます。<br/>
        ・フォローした課題はマイページの「課題・ソリューション登録・管理」から確認できます。<br/>
        ・課題フォローは後で取消しできます。
      </div>
    </div>
    <div *ngIf="loginUser && listFollowed?.length > 0" class="p-my-3 p-d-flex p-flex-column p-ai-center">
      <div class="p-col-12 p-d-flex p-jc-center p-text-bold tex-med">
        この課題のフォロー団体一覧
      </div>
      <div class="p-grid p-col-12 follow-grid ">
        <!-- <ng-container  > -->
          <div *ngFor="let item of listFollowed" class="p-col-4 p-d-flex p-jc-center">
            <span
              class="link-text"
              [ngClass]="loginUser ? 'pointer':''"
              (click)="moveB211orMoveB212(item.member_id,item.class_id)">
                {{item.organization_name}}
            </span>
          </div>
        <!-- </ng-container> -->
      </div>
    </div>
  </div>

</p-dialog>

<!-- confirm unfollow dialog -->
<p-dialog
  [modal]="true"
  [closable]="!loginUser || loginUser.class_id != 1 || loginUser.class_id != 2"
  [draggable]="false"
  [(visible)]="confirmUnFollowDialogFlag"
  styleClass="follow-dialog"
>
  <div class="header">
    課題フォロー
  </div>
  <div class="p-px-1 body">
    <div class="p-col-12 text-group p-d-flex p-jc-center">
      <div class="p-col-11 text-large">
        <h4 class="p-m-0">「{{agendaTitle}}」</h4>
        <h4 class="p-m-0">のフォローを取り消しますか？</h4>
      </div>
      <div class="button-group p-d-flex p-jc-center">
        <button
          pButton
          type="button"
          label="フォローを取り消す"
          class="button-accept"
          (click)="confirmUnFollow()"
          ></button>
      </div>
      <div class="grey-zone p-mt-3 p-px-3 pb-2">
        <div class="p-d-flex p-ai-center p-jc-center">
          <div>
            <h4 class="p-my-2 p-text-center tex-med">
              ＊課題フォロー取消し
            </h4>
          </div>
        </div>
        ・課題フォローを取り消すとフォロー団体一覧から除外され、提案が受けられなくなります。<br>
        ・フォローを取り消すとマイページの課題一覧からフォロー課題が削除されます。<br>
        ・フォローしている課題に対してすでに提案を受領している場合は、フォローを取り消しても、受領した提案が削除されることはありません。
      </div>
    </div>
    <div  *ngIf="listFollowed?.length > 0" class="p-my-3 p-d-flex p-flex-column p-ai-center">
      <div class="p-col-12 p-d-flex p-jc-center p-text-bold tex-med">
        この課題のフォロー団体一覧
      </div>
      <div class="p-grid p-col-12 follow-grid" >
        <!-- <ng-container  > -->
          <div *ngFor="let item of listFollowed" class="p-col-4 p-d-flex p-jc-center">
            <span
              class="link-text"
              [ngClass]="loginUser ? 'pointer':''"
              (click)="moveB211orMoveB212(item.member_id,item.class_id)">
                {{item.organization_name}}
            </span>
          </div>
        <!-- </ng-container> -->
      </div>
    </div>
  </div>
</p-dialog>
